import React, { FC, ReactElement } from 'react';
import { clearStorage } from '../../util';
import withLocalization from '../hoc/withLocalization';

const StartOver: FC<any> = (props: any): ReactElement => {
  const { localize } = props;
  const onCheckInClick = (evt) => {
    clearStorage();
    window.location.href = '/';
  };

  return (
    <>
      <div className="eligibilityButton">
        <button className="checkInButton palmBg upperCase" onClick={onCheckInClick}>
          {localize('preview-sales-engine.static-content.copy.After Payment Page.start-over-button')}
        </button>
      </div>
    </>
  );
};

export default withLocalization(StartOver);
